// store/modules/lidars.js — выбор лидара, данные которого показываем.
//
// Бэкенд хранит измерения в таблицах measurements_{lidar_id} и принимает
// ?lidar_id=N во всех ручках данных; без параметра подставляет лидар по
// умолчанию. Выбранный здесь id добавляется ко всем запросам axios
// interceptor'ом в main.js. Селектор в NavBar показывается только если
// пользователю доступно больше одного лидара.
import axios from 'axios';

const state = {
  list: [],
  defaultId: null,
  selectedId: null,
};

const getters = {
  stateLidars: (state) => state.list,
  selectedLidarId: (state) => state.selectedId,
  hasLidarChoice: (state) => state.list.length > 1,
  selectedLidar: (state) => state.list.find((l) => l.id === state.selectedId) || null,
};

const actions = {
  async fetchLidars({ commit, state }) {
    try {
      const { data } = await axios.get('/lidars');
      commit('setLidars', data);
      // Сохранённый выбор мог устареть (доступ отозван) — сбрасываем на дефолт.
      const stillValid = data.lidars.some((l) => l.id === state.selectedId);
      if (!stillValid) {
        const fallback = data.lidars.some((l) => l.id === data.default_lidar_id)
          ? data.default_lidar_id
          : (data.lidars[0]?.id ?? null);
        commit('setSelectedLidar', fallback);
      }
      return data;
    } catch (error) {
      console.error('Failed to fetch lidars:', error);
      return null;
    }
  },
  selectLidar({ commit }, id) {
    commit('setSelectedLidar', id);
  },
};

const mutations = {
  setLidars(state, { lidars, default_lidar_id: defaultId }) {
    state.list = lidars || [];
    state.defaultId = defaultId ?? null;
  },
  setSelectedLidar(state, id) {
    state.selectedId = id;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
